export class AppSettings {
  private static PRODUCTION_APP_URL: string = 'https://ask.lubbu.com';
  private static SANDBOX_APP_URL: string = 'https://dev-lubbu.abbit.io';

  private static PRODUCTION_ENDPOINT: string =
    'https://us-central1-lubbu-35560.cloudfunctions.net/api';
  private static SANDBOX_ENDPOINT: string =
    'https://us-central1-lubbu-test.cloudfunctions.net/api';
  private static DEV_ENDPOINT: string =
    'https://us-central1-lubbu-test.cloudfunctions.net/api';

  private static PRODUCTION_STRIPE = 'pk_live_qLw9Z0ZqCVqkV8hAHf5NIRwj';
  private static SANDBOX_STRIPE = 'pk_test_fI83If84OTc26SKSCRJevLsn';

  public static isSandbox: boolean = true;
  private static isDev: boolean = window.location.hostname === 'localhost';

  public static isApp: boolean = !document.URL.startsWith('http');

  private static PRODUCTION_FIREBASE = {
    apiKey: 'AIzaSyD7VljdTxKbWcG5VlY2HaLgORf77Cm31pQ',
    authDomain: 'lubbu-35560.firebaseapp.com',
    databaseURL: 'https://lubbu-35560.firebaseio.com',
    projectId: 'lubbu-35560',
    storageBucket: 'lubbu-35560.appspot.com',
    messagingSenderId: '489431909034'
  };

  public static FLURRY = {
    apiKey: 'NTG822Z64MFM4QP5P4B6'
  };

  private static SANDBOX_FIREBASE = {
    apiKey: 'AIzaSyDw-JRURxR_uCqUvzfTy7dBpRECYlANuYc',
    authDomain: 'lubbu-test.firebaseapp.com',
    databaseURL: 'https://lubbu-test.firebaseio.com',
    projectId: 'lubbu-test',
    storageBucket: 'lubbu-test.appspot.com',
    messagingSenderId: '510854041285'
  };

  private static FB_APP_ID_SANDBOX = '482089422199532';
  private static FB_APP_ID_PRODUCTION = '135819713894112';

  public static UNSPLASH_CLIENT_ID =
    '61046776dcc5a95d26d64f10c5c875c69255e1ddb7580496edd376a4ed763437';

  constructor() {}

  public static getFirebaseConfig() {
    if (this.isSandbox) {
      return this.SANDBOX_FIREBASE;
    } else {
      return this.PRODUCTION_FIREBASE;
    }
  }

  public static getAppURL() {
    if (this.isSandbox) {
      return this.SANDBOX_APP_URL;
    } else {
      return this.PRODUCTION_APP_URL;
    }
  }

  public static getEndpoint() {
    if (this.isDev) {
      return this.DEV_ENDPOINT;
    } else if (this.isSandbox) {
      return this.SANDBOX_ENDPOINT;
    } else {
      return this.PRODUCTION_ENDPOINT;
    }
  }

  public static getStripeKey() {
    if (this.isSandbox) {
      return AppSettings.SANDBOX_STRIPE;
    } else {
      return AppSettings.PRODUCTION_STRIPE;
    }
  }

  public static getFBAppID() {
    if (this.isSandbox) {
      return AppSettings.FB_APP_ID_SANDBOX;
    } else {
      return AppSettings.FB_APP_ID_PRODUCTION;
    }
  }

  public static API_ENDPOINT: string = AppSettings.getEndpoint();
  public static STRIPE_KEY: string = AppSettings.getStripeKey();
  public static APP_URL: string = AppSettings.getAppURL();
}



// WEBPACK FOOTER //
// ./src/app/app.settings.ts